module.exports = __webpack_public_path__ + "img/arroba 1.20af1eb8.svg";